var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPasswordShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9977 6.38477C6.00934 6.38477 3.36737 11.4048 3.03287 12.094C3.00816 12.145 3.00816 12.1993 3.03287 12.2502C3.3674 12.9393 6.00938 17.9582 11.9977 17.9582C17.9859 17.9582 20.6279 12.9393 20.9624 12.2502C20.9872 12.1993 20.9872 12.145 20.9624 12.094C20.6279 11.4048 17.986 6.38477 11.9977 6.38477Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 15.3868C13.775 15.3868 15.2144 13.9475 15.2144 12.172C15.2144 10.3964 13.775 8.95711 11.9995 8.95711C10.224 8.95711 8.7847 10.3964 8.7847 12.172C8.7847 13.9475 10.224 15.3868 11.9995 15.3868Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPasswordShow);
export default __webpack_public_path__ + "static/media/ic_password_show.599294981e7d7f630f743d714d95736f.svg";
export { ForwardRef as ReactComponent };